import image1 from '../Images/website_image1.png'
import image2 from '../Images/website_image2.png'
import image3 from '../Images/website_image3.png'

export const Work = [
    {
        id:1,
        name:"URL Shortner",
        description:"A Full Stack Web Application for Shortening URL where a user can create short urls for very long urls once logged in and could also see stats for all urls such as number of clicks and cities from where clicks came from. All urls within last 48hrs from all users are displayed on Home screen and after 48hrs urls automatically get deleted.",
        tags:"React | Express | MongoDB",
        image:image1,
        github:"https://github.com/Parag-Tharani/Url-Shortner",
        demo:"https://url-shortening-web-app.netlify.app/",
        
    },
    {
        id:2,
        name:"College World",
        description:"A Full Stack College Info Website where a user can get college list and also search particular college according to college name , city , state. And also provided Visual Representation of college list according to state for better understanding data. And also created algorithm for getting similar college for a particualr college which takes location, course and some other factors in consideration. ",
        tags:"React | Express | MongoDB | Material ui",
        image:image3,
        demo:"https://college-world.netlify.app/",
        github:"https://github.com/Parag-Tharani/College-World"
        
    },
    {
        id:3,
        name:"Nykaa Clone",
        description:"A clone of e-commerce built with team of 5 people. Area of Responsibility was to make backend for user authentication and to also handle the same in frontend. And to make authentication manually as well as with google Auth. And also to maintain user logged in state for whole app with the help of redux.",
        tags:"React | Redux | Express | MongoDB",
        image:image2,
        github:"https://github.com/tushar-1910/nykaa-clone",
        demo:"https://nykaa-web-app.netlify.app/",
    }
] 